import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./Components/Auth/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
// import Message from "./Components/Dashboard/Message/Message";
import Configure from "./Components/Dashboard/Configure/Configure";
import { AuthProvider } from "./Contexts/AuthContext/AuthContext";
import AddProperty from "./Components/PropertySetup/AddProperty/AddProperty";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropertyDashboard from "./Components/PropertySetup/PropertyDashboard/PropertyDashboard";
import ProtectedRoute from "./Routes/ProtectedRoutes/ProtectedRoute";
import Home from "./Components/Dashboard/Home/Home";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropertyProvider } from "./Contexts/PropertyContext/PropertyContext";
import Register from "./Components/Auth/Register/Register";
import { SocketProvider } from "./Contexts/SocketContext/SocketContext";

import TemplateForm from "./Components/Dashboard/Configure/TemplateForm/TemplateForm";
import { Workflow } from "./Components/Dashboard/Configure/Workflow/Workflow";
import TwilioSetup from "./Components/Dashboard/Configure/TwiloSetup/TwiloSetup";
import UpdateProperty from "./Components/PropertySetup/UpdateProperty/UpdateProperty";
import Overview from "./Components/Dashboard/Analytics/Overview";
import Details from "./Components/Dashboard/Analytics/Details";
import Review from "./Components/ReviewModal/Review";
import PmsIntegration from "./Components/Dashboard/Configure/PmsIntegration/PmsIntegration";
import PlatformLinking from "./Components/Dashboard/Configure/PlatformLinking/PlatformLinking";
import GoogleCallback from "./Components/Dashboard/Configure/PlatformLinking/GoogleCallback";
import ForgotPassword from "./Components/Auth/ForgotPassword/ForgotPassword";
import Notification from "./Components/Dashboard/Configure/Notification/Notification";
import Reviews from "./Components/Dashboard/Reviews/Reviews";
import RequireFieldSetting from "./Components/Dashboard/Configure/RequireFieldSetting/RequireFieldSetting";
import Wallet from "./Components/CreditSetup/Wallet";
import AddCredits from "./Components/CreditSetup/AddCredits";
import Failure from "./Components/CreditSetup/Failure";
import Success from "./Components/CreditSetup/Success";
import Checkout from "./Components/CreditSetup/Checkout";
import Transactions from "./Components/CreditSetup/Transaction";
import ReviewDashboard from "./Components/ReviewDashboard/ReviewDashboard";
import TeamMemberManagement from "./Components/TeamMember/TeamMemberManagement";

const queryClient = new QueryClient();

function App() {
	return (
		<div className="font-poppins">
			{/* toast container for the toast */}
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				// transition: Bounce
			/>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<PropertyProvider>
						<SocketProvider>
							<Routes>
								<Route path="/" element={<Login />} />
								<Route path="/register" element={<Register />} />
								<Route path="/forgotpassword" element={<Login />} />
								<Route path="/resetpassword" element={<Login />} />
								<Route path="/" element={<ProtectedRoute />}>
									<Route path="/dashboard" element={<Dashboard />}>
										<Route path="/dashboard" element={<Home />}></Route>
										<Route path="/dashboard/configure" element={<Configure />}>
											<Route
												path="/dashboard/configure/template"
												element={<TemplateForm />}
											/>
											<Route
												path="/dashboard/configure/workflow"
												element={<Workflow />}
											/>
											<Route
												path="/dashboard/configure/twilio"
												element={<TwilioSetup />}
											/>
											<Route
												path="/dashboard/configure/requirefields"
												element={<RequireFieldSetting />}
											/>
											<Route
												path="/dashboard/configure/pms"
												element={<PmsIntegration />}
											/>
											<Route
												path="/dashboard/configure/notification"
												element={<Notification />}
											/>
											<Route
												path="/dashboard/configure/platform-linking"
												element={<PlatformLinking />}
											/>
										</Route>
										<Route path="/dashboard/analytics" element={<Overview />} />
										<Route
											path="/dashboard/analytics/details"
											element={<Details />}
										/>
										<Route
											path="/dashboard/updateproperty"
											element={<UpdateProperty />}
										/>
										<Route path="/dashboard/review" element={<Review />} />
										<Route path="/dashboard/reviews" element={<Reviews />} />
										<Route
											path="/dashboard/review-overview"
											element={<ReviewDashboard />}
										/>
										<Route path="/dashboard/wallet" element={<Wallet />} />
										<Route
											path="/dashboard/add-credits"
											element={<AddCredits />}
										/>
										<Route path="/dashboard/checkout" element={<Checkout />} />
										<Route path="/dashboard/success" element={<Success />} />
										<Route
											path="/dashboard/payment-failed"
											element={<Failure />}
										/>
										<Route
											path="/dashboard/transactions"
											element={<Transactions />}
										/>
										<Route
											path="/dashboard/team-member"
											element={<TeamMemberManagement />}
										/>
									</Route>

									<Route path="/addproperty" element={<AddProperty />} />
									<Route path="/propertyhome" element={<PropertyDashboard />} />
								</Route>
								<Route
									path="/auth/google/callback"
									element={<GoogleCallback />}
								/>
							</Routes>
						</SocketProvider>
					</PropertyProvider>
				</AuthProvider>
			</QueryClientProvider>
		</div>
	);
}

export default App;
